// Adds or drops one id in a control's `aria-describedby`, so it only points at a message
// while that message is shown, and leaves any other id (a description) in place.
export default function describeBy(element, id, present) {
  const ids = (element.getAttribute('aria-describedby') || '')
    .split(' ')
    .filter(existing => existing && existing !== id);

  if (present) ids.unshift(id);

  if (ids.length) {
    element.setAttribute('aria-describedby', ids.join(' '));
  } else {
    element.removeAttribute('aria-describedby');
  }
}
